const initialState = {};

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case "table.partner_members/SET_TABLE_PARAMS":
			return {
				...state,
				...action.params
			};
		case "table.partner_members/LIST_PARTNER_MEMBERS_SUCCESS":
			return {
				...state,
				data: action.response.data,
                filters: action.response.filters,
				...action.response.pagination
			};
		default:
			return state;
	}
}
